import { render, staticRenderFns } from "./place.vue?vue&type=template&id=e0403f56&scoped=true"
import script from "./place.vue?vue&type=script&lang=js"
export * from "./place.vue?vue&type=script&lang=js"
import style0 from "./place.vue?vue&type=style&index=0&id=e0403f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0403f56",
  null
  
)

export default component.exports